import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70a3224c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=70a3224c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a3224c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a3224c')) {
      api.createRecord('70a3224c', component.options)
    } else {
      api.reload('70a3224c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70a3224c&scoped=true", function () {
      api.rerender('70a3224c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/retailer/order/index.vue"
export default component.exports